import CustomersRepository from "./CustomersRepository";
import CustomerContactsRepository from "./CustomerContactsRepository";
import CustomerLocationsRepository from "./CustomerLocationsRepository";
import CustomerGrowersRepository from "./CustomerGrowersRepository";
import CustomerFieldsRepository from "./CustomerFieldsRepository";

const repositories = {
  customers: CustomersRepository,
  customerContacts: CustomerContactsRepository,
  customerLocations: CustomerLocationsRepository,
  customerGrowers: CustomerGrowersRepository,
  customerFields: CustomerFieldsRepository
};

export const CrmRepositoryFactory = {
  get: name => repositories[name]
};
